import styled from 'styled'
import StyledInput from './styled-input'

export default styled.input`
  ${StyledInput}
`
